import React from "react";
import { CheckCircle, X } from "lucide-react";

const FOR = [
  "Small biotech labs.",
  "Diagnostics labs.",
  "Single-site pharma teams.",
  "Lean QA groups with documentation bottlenecks.",
  "Teams evaluating AI in regulated workflows.",
];

const NOT_FOR = [
  "Labs looking for unrestricted AI writing with no review controls.",
  "Organizations trying to replace their full enterprise QMS immediately.",
  "Teams with no defined workflow to evaluate.",
];

export default function ValidationWhoItsFor() {
  return (
    <section className="py-14 sm:py-16 bg-muted/30 border-b border-border">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl sm:text-3xl font-bold text-foreground tracking-tight mb-4">
          Who this is for
        </h2>
        <p className="text-base text-muted-foreground leading-relaxed mb-8 max-w-2xl">
          This assessment is best for small regulated labs that want to use AI in quality or validation work without creating uncontrolled documentation risk. It fits teams dealing with CAPAs, deviations, validation records, SOP changes, and audit-prep pressure.
        </p>
        <div className="grid sm:grid-cols-2 gap-6 max-w-3xl">
          <div className="bg-card border border-border rounded-xl p-6">
            <p className="text-sm font-semibold text-foreground mb-4">Good fit:</p>
            <ul className="space-y-3">
              {FOR.map((item) => (
                <li key={item} className="flex items-start gap-2.5">
                  <CheckCircle className="w-4 h-4 text-secondary shrink-0 mt-0.5" />
                  <span className="text-sm text-muted-foreground">{item}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="bg-muted/40 border border-dashed border-border rounded-xl p-6">
            <p className="text-sm font-semibold text-muted-foreground mb-4">Not ideal:</p>
            <ul className="space-y-3">
              {NOT_FOR.map((item) => (
                <li key={item} className="flex items-start gap-2.5">
                  <X className="w-4 h-4 text-muted-foreground/50 shrink-0 mt-0.5" />
                  <span className="text-sm text-muted-foreground">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}